<template>
  <div class="col">
    <div class="content-i">
      <div class="content-box pt-0">
        <h5 class="form-header">
          Pedidos Ativos
        </h5>
        <div class="row">
          <div class="col text-right" style="margin-bottom: 5px">
            <button type="button" class="btn btn-primary">Atualizar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"
            v-for="pedido in pedidos" :key="pedido._id">
            <a href="#" class="element-box el-tablo">
              <div class="row">
                <div class="col-6">
                  <div v-if="pedido.pagamentoAto" class="badge badge-pill badge-success">
                    Compra Aprovada <small>Pagamento no Local</small>
                  </div>
                  <div v-else-if="pedido.statusPagamento === 'CONCLUIDO'" class="badge badge-pill badge-success">
                    Compra Aprovada
                  </div>
                  <div v-else class="badge badge-pill badge-warning">
                    Aguardando pagamento
                  </div>
                </div>
                <div class="col">
                  <div class="label">Efetuado em: {{pedido.transacao ? getDataFormatada(pedido.transacao.created_at) : getDataFormatada(pedido.createdAt)}}</div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Número do Pedido
                  </div>
                  <div class="value">
                    <h5>{{pedido.codigo}}</h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="label">
                    Status Atendimento
                  </div>
                  <div v-if="pedido.statusAtendimento === 'REALIZADO'" class="badge badge-success">
                    {{pedido.tipoPedido}} REALIZADO(A)
                  </div>
                  <div v-else class="badge badge-warning">
                    Aguardando Atendimento
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Cliente
                  </div>
                  <h6>{{user.name}}</h6>
                </div>

              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Local
                  </div>
                  <h6>{{pedido.unidade.nomeRede}}</h6>
                  <small class="sub-value">{{endereco(pedido.unidade)}}</small>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col">
                  <router-link tag="a" class="btn btn-primary mb-3 btn-sm" target="_blank" :to="{name: 'Voucher',query: {id: pedido._id}}"><span>Ver Detalhes</span></router-link>
                  <button v-if="pedido.statusAtendimento === 'REALIZADO' && !pedido.atendimentoAvaliado" type="button" @click="modalAvaliar(pedido._id)" class="btn btn-success mb-3 btn-sm">Avaliar</button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="content-box pt-0">
        <h5 class="form-header">
          Pedidos Para realizar pagamento no local
        </h5>
        <div class="row">
          <div class="col text-right" style="margin-bottom: 5px">
            <button type="button" class="btn btn-primary">Atualizar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"
            v-for="pedido in pedidosPagamentoNoLocal" :key="pedido._id">
            <a href="#" class="element-box el-tablo">
              <div class="row">
                <div class="col-6">
                  <div v-if="pedido.pagamentoAto" class="badge badge-pill badge-success">
                    Pedido Aprovado <small>Pagamento no Local</small>
                  </div>
                  <div v-else-if="pedido.statusPagamento === 'CONCLUIDO'" class="badge badge-pill badge-success">
                    Compra Aprovada
                  </div>
                  <div v-else class="badge badge-pill badge-warning">
                    Aguardando pagamento
                  </div>
                </div>
                <div class="col">
                  <div class="label">Efetuado em: {{pedido.transacao ? getDataFormatada(pedido.transacao.created_at) : getDataFormatada(pedido.createdAt)}}</div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Número do Pedido
                  </div>
                  <div class="value">
                    <h5>{{pedido.codigo}}</h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="label">
                    Status Atendimento
                  </div>
                  <div v-if="pedido.statusAtendimento === 'REALIZADO'" class="badge badge-success">
                    {{pedido.tipoPedido}} REALIZADO(A)
                  </div>
                  <div v-else class="badge badge-warning">
                    Aguardando Atendimento
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Cliente
                  </div>
                  <h6>{{user.name}}</h6>
                </div>

              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Local
                  </div>
                  <h6>{{pedido.unidade.nomeRede}}</h6>
                  <small class="sub-value">{{endereco(pedido.unidade)}}</small>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col">
                  <router-link tag="a" class="btn btn-primary mb-3 btn-sm" target="_blank" :to="{name: 'Voucher',query: {id: pedido._id}}"><span>Ver Detalhes</span></router-link>
                  <button v-if="pedido.statusAtendimento === 'REALIZADO' && !pedido.atendimentoAvaliado" type="button" @click="modalAvaliar(pedido._id)" class="btn btn-success mb-3 btn-sm">Avaliar</button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="content-box pt-0">
        <h5 class="form-header">
          Pedidos Aguardando confirmação de pagamento
        </h5>
        <div class="row">
          <div class="col text-right" style="margin-bottom: 5px">
            <button type="button" class="btn btn-primary">Atualizar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"
            v-for="pedido in pedidosAguardandoPagamento" :key="pedido._id">
            <a href="#" class="element-box el-tablo">
              <div class="row">
                <div class="col-6">
                  <div v-if="pedido.pagamentoAto" class="badge badge-pill badge-success">
                    Compra Aprovada <small>Pagamento no Local</small>
                  </div>
                  <div v-else-if="pedido.statusPagamento === 'CONCLUIDO'" class="badge badge-pill badge-success">
                    Compra Aprovada
                  </div>
                  <div v-else class="badge badge-pill badge-warning">
                    Aguardando pagamento
                  </div>
                </div>
                <div class="col">
                  <div class="label">Efetuado em: {{pedido.transacao ? getDataFormatada(pedido.transacao.created_at) : getDataFormatada(pedido.createdAt)}}</div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Número do Pedido
                  </div>
                  <div class="value">
                    <h5>{{pedido.codigo}}</h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="label">
                    Status Atendimento
                  </div>
                  <div v-if="pedido.statusAtendimento === 'REALIZADO'" class="badge badge-success">
                    {{pedido.tipoPedido}} REALIZADO(A)
                  </div>
                  <div v-else class="badge badge-warning">
                    Aguardando Atendimento
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Cliente
                  </div>
                  <h6>{{user.name}}</h6>
                </div>

              </div>
              <br>
              <div class="row">
                <div class="col">
                  <div class="label">
                    Local
                  </div>
                  <h6>{{pedido.unidade.nomeRede}}</h6>
                  <small class="sub-value">{{endereco(pedido.unidade)}}</small>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col">
                  <router-link tag="a" class="btn btn-primary mb-3 btn-sm" target="_blank" :to="{name: 'Voucher',query: {id: pedido._id}}"><span>Ver Detalhes</span></router-link>
                  <button v-if="pedido.statusAtendimento === 'REALIZADO' && !pedido.atendimentoAvaliado" type="button" @click="modalAvaliar(pedido._id)" class="btn btn-success mb-3 btn-sm">Avaliar</button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="onboardingWideFormModal" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="os-icon os-icon-close"></span></button>
          <div class="onboarding-content with-gradient">
              <h4 class="onboarding-title">
                Avalie o seu atendimento
              </h4>

              <form>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Avalie seu atendimento.</label>
                      <rate :length="5" v-model="depoimento.nota" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Comentário</label>
                      <textarea v-model="depoimento.descricao" class="form-control" name="basic" placeholder="Como foi seu atendimento?">
                      </textarea>
                    </div>
                  </div>

                </div>

              </form>
            </div>
            <div class="modal-footer">
            <button @click="saveDepoimento()" class="btn btn-outline-primary" type="button"> Salvar</button>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>
<script>
import * as axios from 'axios'
import moment from 'moment'

export default {
  computed: {
    logado () {
      return this.$store.getters.user
    },
    naoLogado () {
      return !this.$store.getters.user
    },
    user () {
      return this.$store.getters.user
    },
    utilizaAgendamento () {
      return this.$store.getters.rede && this.$store.getters.rede.agendamento
    }
  },
  watch: {
    rede (value) {
      console.log('watch rede', value)
      if (!value) {
        this.$store.dispatch('rede', this.$store.getters.user.rede._id)
      }
    }
  },
  data () {
    return {
      pedidos: [],
      pedidosAguardandoPagamento: [],
      pedidosPagamentoNoLocal: [],
      depoimento: {}
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({name: 'Login'}))
    },
    endereco (unidade) {
      return `${unidade.localAtendimento}, numero ${unidade.numero}, ${unidade.bairro}, ${unidade.cidade} - ${unidade.uf}`
    },
    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    },
    modalAvaliar (idPedido) {
      this.$store.dispatch('setLoading', true)
      axios.get('/depoimentos?pedido=' + idPedido)
        .then(response => {
          let depoimento = response.data
          if (!depoimento) {
            this.$store.dispatch('setLoading', false)
          }
          this.$store.dispatch('setLoading', false)
          this.depoimento = depoimento[0]
          window.jQuery('#onboardingWideFormModal').modal('show')
        })
    },
    saveDepoimento () {
      axios.put(`/depoimentos/${this.depoimento._id}`, this.depoimento)
        .then(response => {
          axios.get('/pedidos?populate=unidade&cliente=' + this.$store.getters.user.id)
            .then(response => {
              this.pedidos = response.data
              window.jQuery('#onboardingWideFormModal').modal('hide')
            })
        })
    }
  },
  created () {
    moment.locale('pt-br')
  },
  async mounted () {
    axios.get('/pedidos?populate=unidade&statusPagamento=CONCLUIDO&statusAtendimento=AGUARDANDO&cliente=' + this.$store.getters.user.id)
      .then(response => {
        this.pedidos = response.data.filter(p => p.unidade != null)
      })
    axios.get('/pedidos?populate=unidade&statusPagamento=AGUARDANDO_PAGAMENTO&statusAtendimento=AGUARDANDO&cliente=' + this.$store.getters.user.id)
      .then(response => {
        this.pedidosAguardandoPagamento = response.data.filter(p => p.unidade != null)
      })

    const responsePedidoPagamentoAto = await axios.get(`/pedidos?populate=unidade&pagamentoAto=true&statusAtendimento=AGUARDANDO&cliente=${this.$store.getters.user.id}`)
    this.pedidosPagamentoNoLocal = responsePedidoPagamentoAto.data.filter(p => p.unidade != null)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard-cliente/HomeAdmCliente.vue